import { getFileNameFromSasUrl } from '@app/helper/fileHelper';
import API_PATHS from '../network/apiPaths';
import NetworkService from '../network/NetworkService';
import { getBase64UriFromBuffer } from '@app/helper/fileHelper';

export const fileAccessService = async ({
  sasUrl,
  contentType,
  useReportingHost,
}: {
  sasUrl: string;
  contentType?: string;
  useReportingHost?: boolean;
}) => {

  try {
    const url = `${API_PATHS.DOCUMENT_DOWNLOAD}?sasUrl=${encodeURIComponent(sasUrl)}`;
    const response = await NetworkService.get(
      url,
      // useReportingHost drives host selection in getBaseURL; it also lands in the
      // querystring as an extra param, which the backend ignores
      { sasUrl, useReportingHost },
      null,
      false,
      'arraybuffer'
    );
    contentType = contentType ? contentType : response.headers?.['content-type'] || 'application/octet-stream';
    const extractedFileName = getFileNameFromSasUrl(sasUrl);
    const base64data = arrayBufferToBase64(response.data, contentType);
    return {
      success: true,
      platform: "web",
      fileName: extractedFileName,
      contentType,
      base64data, // ✅ Now guaranteed to be ready
    };
  } catch (error) {
    throw error;
  }
};

function arrayBufferToBase64(buffer: any, mimeType = "application/pdf") {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const chunkSize = 8192; // prevents call stack overflow

  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk: any = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode.apply(null, chunk);
  }

  const base64String = window.btoa(binary); // ✅ FIX: no encodeURIComponent
  const base64DataString = getBase64UriFromBuffer(base64String, mimeType);
  
  return base64DataString;
}

export const downloadFromBase64Web = (base64Data: string, fileName: string) => {
  const downloadLink = document?.createElement('a')
    ? document?.createElement('a')
    : { href: '', download: '', click: () => true };
  downloadLink.href = base64Data;
  downloadLink.download = fileName;
  downloadLink.click();
  return null;
}
